import gql from 'graphql-tag';
export default gql`
	mutation UpdateModalRegister($isOpen: String, $isBack: String) {
		updateModalRegister(isOpen: $isOpen, isBack: $isBack) @client
	}
`;
